<template>
<div id="main_div">
  <section id="home" class="home mobile home-three vertical-scrolling container-fluidback">
    <!-- Background animation -->
    <div class="background calcSection">
      <div class="cube"></div>
      <div class="cube"></div>
      <div class="cube"></div>
      <div class="cube"></div>
      <div class="hexagon"></div>
      <b-container class="ml-4 mobile bigscreen">
        <b-row class="container mt-1 ml-4 mainSpacing">
          <b-col class="col-sm-12 col-md-7 col-lg-6 calcpart">
            <b-row class="col-12 main-title">
              <h2 class="text-left titlefont">
                Easily Pay For Your Car Repair
              </h2>
            </b-row>
            <b-row>
              <h3 class="text-left subtitlefont">
                Low Interest 0%-14.9%
              </h3>
            </b-row>
            <b-row>
              <h5 class="text-left subtitlefont">
                No Credit Checks
              </h5>
            </b-row>

            <b-row class="zeroInt pt-4">
              <b-col class="col-12">
                <h4>
                  6 Months = 0% Interest!!
                </h4>
              </b-col>
            </b-row>

            <b-row>
              <b-col class="zeroInt col-12 text-center mt-3">
                <p style="font-size:6px;">(Available at selected locations)
                </p>
              </b-col>
            </b-row>

            <!-- Paybox Calculator -->
            <b-container class="mt-4 boxheight" fluid style="background: transparent;">
              <b-row>
                <b-col class="paybox mt-2 col-lg-10 col-sm-9">
                  <b-row class="estimatebox">
                    <b-col sm="5" class="mt-2 textestimate">
                      <div style="vertical-align: middle">
                        <label style="vertical-align: middle" for="input-small" class="text-white adjustFont">Enter Estimate:</label>
                      </div>
                    </b-col>
                    <b-col class="text-center center mt-2" sm="7" lg="" md="">
                      <div>
                        <b-input-group key="sm" size="sm" class="mb-3" prepend="$">
                          <b-form-input ref="Estimate" v-model="calcinput" type="number" size="sm" placeholder="1650" name="Estimate" class="paymentBox"></b-form-input>
                        </b-input-group>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="radioMonth">
                    <b-col class="text-center px-1 px-md-3">
                      <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-radio-group id="btn-radios-1" v-model="selected" :options="options" :aria-describedby="ariaDescribedby" name="radios-btn-default" buttons class="custom-radio-buttons" @change="selectedPlan()"></b-form-radio-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-container class="paymentplan">
                    <b-row class="text-center" align-v="center">
                      <b-col class="text-center">
                        <p class="offer text-center">
                          ${{updatedPayment}}
                        </p>
                      </b-col>
                      <b-col class="d-flex flex-column justify-content-center align-items-center">
                        <p class="mb-1" style="color:white;">No payment 90 days:</p>
                        <b-input-group-append>
                          <b-button 
                            size="sm" 
                            :style="{ 'background-color': noPaymentActive ? 'green !important' : 'grey !important' }" 
                            variant="success" 
                            @click="noPayment()">
                              {{ noPaymentActive ? 'Activated' : 'Click To Activate' }}
                          </b-button>
                        </b-input-group-append>
                      </b-col>
                    </b-row>
                  </b-container>
                  <b-container class="bv-example-row pt-2 mb-3">
                    <b-row class="justify-content-md-center adjustSmall">
                      <b-col class="col-5 text-center">
                        <div>
                          <b-form-select v-model="poSelected" :options="payOptions" size="sm" class="text-center" @change="selectedPlan()"></b-form-select>
                        </div>
                      </b-col>
                      <b-col class="col-5 text-center">
                        <b-button id="startedbtn" class="text-center" size="sm" @click="submit">
                          <b>Next</b>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
          <div class="pt-4 mainback text-center col-lg-6 col-md-5">
            <div>
              <b-img :src="require('../assets/fixiphonesix.png')" fluid alt="Responsive image" class="smimgres"></b-img>
            </div>
          </div>
        </b-row>
      </b-container>
    </div>
  </section>
  <About />
  <Feature />
  <Contact_us />
</div>
</template>

<script>
import About from '../components/about'

export default {
  name: 'Home',
  components: {
    About,
  },
  data() {
    return {
      selected: 'radio3',
      poSelected: 'semimonthly',
      payOptions: [
        {
          text: 'Monthly',
          value: 'monthly',
        },
        {
          text: 'Semi Monthly',
          value: 'semimonthly',
        },
        {
          text: 'Bi-Weekly',
          value: 'biweekly',
        },
        {
          text: 'Weekly',
          value: 'weekly',
        },
      ],
      options: [
        {
          text: '6 Months',
          value: 'radio1',
        },
        {
          text: '12 Months',
          value: 'radio2',
        },
        {
          text: '24 Months',
          value: 'radio3',
        },
        {
          text: '36 Months',
          value: 'radio4',
        },
      ],
      dismissSecs: 10,
      calcinput: 1650,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      frequencyOfPayments: ['Monthly', 'Semi-monthly', 'Bi-weekly', 'Weekly'],
      amount: '1650',
      paymentType: '3',
      paymentTypeButton: false,
      repairOfferAmount: '1650',
      updatedPayment: '45.1',
      fees: '87',
      rate: '14.9',
      term: '24',
      isHidden: true,
      selectedRepair: 'Choose...',
      repairOptions: [
        'Mechanical',
        'Collision',
        'Electrical',
        'Rust',
        'Exhaust',
        'Rims And Tires',
        'Choose...',
      ],
      isToggled: false,
      originalAmount: null,
      noPaymentActive: false,
    }
  },
  watch: {
    noPaymentActive() {
      const localThis = this
      if (this.calcinput < 10001 && this.calcinput > 499) {
        localThis.repairOfferAmount = localThis.calcinput
        if (localThis.poSelected === 'monthly' && localThis.selected === 'radio2') {
          // 12 months and Semi monthly [3,12]
          localThis.calculatePayment.call(this, [3, 12])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio2') {
          localThis.calculatePayment.call(this, [2, 12])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio3') {
          localThis.calculatePayment.call(this, [3, 24])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [3, 36])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio3') {
          localThis.calculatePayment.call(this, [2, 24])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [2, 36])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio1') {
          localThis.calculatePayment.call(this, [2, 6])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio1') {
          localThis.calculatePayment.call(this, [3, 6])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio2') {
          localThis.calculatePayment.call(this, [0, 12])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio2') {
          localThis.calculatePayment.call(this, [1, 12])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio3') {
          localThis.calculatePayment.call(this, [0, 24])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [0, 36])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio3') {
          localThis.calculatePayment.call(this, [1, 24])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [1, 36])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio1') {
          localThis.calculatePayment.call(this, [1, 6])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio1') {
          localThis.calculatePayment.call(this, [0, 6])
        } else if (this.poSelected === 'biweekly' && this.selected === 'radio2') {
          this.calculatePayment.call(this, [1, 12])
        } else if (this.poSelected === 'weekly' && this.selected === 'radio2') {
          this.calculatePayment.call(this, [0, 12])
        } else if (this.poSelected === 'biweekly' && this.selected === 'radio3') {
          this.calculatePayment.call(this, [1, 24])
        } else if (this.poSelected === 'biweekly' && this.selected === 'radio4') {
          this.calculatePayment.call(this, [1, 36])
        } else if (this.poSelected === 'weekly' && this.selected === 'radio3') {
          this.calculatePayment.call(this, [0, 24])
        } else if (this.poSelected === 'weekly' && this.selected === 'radio4') {
          this.calculatePayment.call(this, [0, 36])
        } else if (this.poSelected === 'weekly' && this.selected === 'radio1') {
          this.calculatePayment.call(this, [0, 6])
        } else if (this.poSelected === 'biweekly' && this.selected === 'radio1') {
          this.calculatePayment.call(this, [1, 6])
        }
      } else if (this.calcinput > 10000) {
        this.updatedPayment = '10K Max.'
      } else if (this.calcinput < 500) {
        this.updatedPayment = '500 Min.'
      }
    },
    calcinput() {
      const localThis = this
      if (this.calcinput < 10001 && this.calcinput > 499) {
        localThis.repairOfferAmount = localThis.calcinput
        if (localThis.poSelected === 'monthly' && localThis.selected === 'radio2') {
          // 12 months and Semi monthly [3,12]
          localThis.calculatePayment.call(this, [3, 12])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio2') {
          localThis.calculatePayment.call(this, [2, 12])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio3') {
          localThis.calculatePayment.call(this, [3, 24])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [3, 36])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio3') {
          localThis.calculatePayment.call(this, [2, 24])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [2, 36])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio1') {
          localThis.calculatePayment.call(this, [2, 6])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio1') {
          localThis.calculatePayment.call(this, [3, 6])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio2') {
          localThis.calculatePayment.call(this, [0, 12])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio2') {
          localThis.calculatePayment.call(this, [1, 12])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio3') {
          localThis.calculatePayment.call(this, [0, 24])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [0, 36])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio3') {
          localThis.calculatePayment.call(this, [1, 24])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [1, 36])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio1') {
          localThis.calculatePayment.call(this, [1, 6])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio1') {
          localThis.calculatePayment.call(this, [0, 6])
        } else if (this.poSelected === 'biweekly' && this.selected === 'radio2') {
          this.calculatePayment.call(this, [1, 12])
        } else if (this.poSelected === 'weekly' && this.selected === 'radio2') {
          this.calculatePayment.call(this, [0, 12])
        } else if (this.poSelected === 'biweekly' && this.selected === 'radio3') {
          this.calculatePayment.call(this, [1, 24])
        } else if (this.poSelected === 'biweekly' && this.selected === 'radio4') {
          this.calculatePayment.call(this, [1, 36])
        } else if (this.poSelected === 'weekly' && this.selected === 'radio3') {
          this.calculatePayment.call(this, [0, 24])
        } else if (this.poSelected === 'weekly' && this.selected === 'radio4') {
          this.calculatePayment.call(this, [0, 36])
        } else if (this.poSelected === 'weekly' && this.selected === 'radio1') {
          this.calculatePayment.call(this, [0, 6])
        } else if (this.poSelected === 'biweekly' && this.selected === 'radio1') {
          this.calculatePayment.call(this, [1, 6])
        }
      } else if (this.calcinput > 10000) {
        this.updatedPayment = '10K Max.'
      } else if (this.calcinput < 500) {
        this.updatedPayment = '500 Min.'
      }
    },
    // The new function
    paymentTypeButton() {
      this.selectedPlan()
    },
  },
  mounted() {
    this.focusInput()

    document.addEventListener('DOMContentLoaded', function(event) {
      // array with texts to type in typewriter
      var dataText = [
        '0%',
        'Interest',
        'For.',
        '6 Months Plans',
        '0%',
        'Interest',
        'For.',
        '6 Months Plans',
        '0%',
        'Interest',
        'For.',
        '6 Months Plans',
        '0%',
        'Interest',
        'For.',
        '6 Months Plans',
        '0%',
        'Interest',
        'For.',
        '6 Months Plans',
        '0%',
        'Interest',
        'For.',
        '6 Months Plans',
        '0%',
        'Interest',
        'For.',
        '6 Months Plans',
        '0%',
        'Interest',
        'For.',
        '6 Months Plans',
        '0%',
        'Interest',
        'For.',
        '6 Months Plans',
      ]

      // type one text in the typwriter
      // keeps calling itself until the text is finished

      function typeWriter(text, i, fnCallback) {
        // chekc if text isn't finished yet
        if (i < text.length) {
          // add next character to h1
          document.querySelector('h4').innerHTML =
            text.substring(0, i + 1) + '<span aria-hidden="true"></span>'

          // wait for a while and call this function again for next character
          setTimeout(function() {
            typeWriter(text, i + 1, fnCallback)
          }, 100)
        }
        // text finished, call callback if there is a callback function
        else if (typeof fnCallback === 'function') {
          // call callback after timeout
          setTimeout(fnCallback, 700)
        }
      }

      // start a typewriter animation for a text in the dataText array
      function StartTextAnimation(i) {
        if (typeof dataText[i] === 'undefined') {
          setTimeout(function() {
            StartTextAnimation(0)
          }, 200)
        }
        // check if dataText[i] exists
        if (i < dataText.length) {
          // text exists! start typewriter animation
          typeWriter(dataText[i], 0, function() {
            // after callback (and whole text has been animated), start next text
            StartTextAnimation(i + 1)
          })
        }
      }
      // start the text animation
      StartTextAnimation(0)
    })
  },
  beforeCreate: function() {
    if (this.$route.query.vendor) {
      this.$store.state.vendor = this.$route.query.vendor || localStorage.getItem('vendor')
      localStorage.setItem('vendor', this.$route.query.vendor)
      this.$router.push({
        path: '/',
      })
    }
    document.body.className = 'home-style three'
    this.$nextTick(() => {
      const buttons = this.$el.querySelectorAll('.custom-radio-buttons .btn span')
      buttons.forEach(button => {
        button.style.fontSize = '0.75rem'
      })
    })
  },
  methods: {
    noPayment() {
      this.noPaymentActive = !this.noPaymentActive
      this.buttonColor = this.noPaymentActive ? 'success' : 'secondary'
      this.$store.state.userData.ninetyDays = this.noPaymentActive
    },

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    process() {
      if (timeout) clearTimeout(timeout)
      this.counter++
      this.seen = true
      this.textSeen = false
      timeout = setTimeout(this.fetchHole, 700)
    },
    fetchHole() {
      this.textSeen = true
      this.seen = false
    },
    focusInput() {
      this.$refs.Estimate.focus()
    },
    next() {
      this.$store.state.userData.selectedRepair = this.selectedRepair
      this.$router.push({
        name: 'VinAndMiles',
      })
    },
    submit() {
      this.$store.state.userData.payment = this.updatedPayment
      this.$store.state.userData.loanRequested = this.repairOfferAmount
      this.$store.state.userData.repairOfferAmount = this.repairOfferAmount
      this.$store.state.userData.paymentPeriod = this.term
      this.$router.push({
        name: 'VinAndMiles',
      })
    },

    calculatePayment(pType) {
      var myThis = this // Note: If you're using arrow functions, you might not need this line.
      const paymentPeriod = [4.33333333, 2.1666666, 2, 1]
      let noPayAmount = this.repairOfferAmount // Default to original amount
      if (this.noPaymentActive === true) {
        noPayAmount =
          parseFloat(this.repairOfferAmount) + (parseFloat(this.repairOfferAmount) * 0.27) / 4
      } else {
        noPayAmount = parseFloat(this.repairOfferAmount)
      }
      const amount = noPayAmount
      const fees = this.fees
      const paymentsPerYear = pType[1] * paymentPeriod[pType[0]]
      this.term = pType[1]
      if (pType[1] === 6) {
        this.$store.state.userData.paymentPeriod = pType[1]
        const interestSix = 0.0001
        let allPayments = 0
        if (amount < 2500) {
          allPayments = parseFloat(amount) + parseFloat(fees) + amount * 0.045
        } else {
          allPayments = parseFloat(amount) + parseFloat(fees) + amount * 0.055
        }
        const totalmonthlypaymentSix = allPayments / paymentsPerYear
        this.$store.state.userData.numberOfPayments = pType[1]
        this.$store.state.userData.paymentPeriods = paymentsPerYear
        this.$store.state.userData.term = this.term
        if (paymentPeriod[pType[0]] === 1) {
          // for frequencyOfPayments:['Monthly','Semi-Monthly'],
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[0]
        } else if (paymentPeriod[pType[0]] === 2) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[1]
        } else if (paymentPeriod[pType[0]] === 2.1666666) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[2]
        } else if (paymentPeriod[pType[0]] === 4.33333333) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[4]
        } else {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[3]
        }
        myThis.$store.state.userData.paymentFees = allPayments - amount
        myThis.$store.state.userData.loanApr = 4
        myThis.updatedPayment = totalmonthlypaymentSix.toFixed(2)
        myThis.$store.state.userData.payment = totalmonthlypaymentSix
        myThis.$store.state.userData.repairOfferAmount = myThis.repairOfferAmount
        myThis.$store.state.userData.loanRequested = myThis.repairOfferAmount
      } else {
        const interest = this.rate
        const rate = parseFloat(interest) / (paymentPeriod[pType[0]] * 12) / 100
        const aprRate = parseFloat(27.9) / (paymentPeriod[pType[0]] * 12) / 100
        const allPayments = parseFloat(amount) + parseFloat(fees)
        let totalmonthlypayment =
          (parseFloat(amount) * aprRate * Math.pow(1 + aprRate, paymentsPerYear)) /
          (Math.pow(1 + aprRate, paymentsPerYear) - 1)
        const noFeesMonthlyPayment =
          (allPayments * rate * Math.pow(1 + rate, paymentsPerYear)) /
          (Math.pow(1 + rate, paymentsPerYear) - 1)
        if (noFeesMonthlyPayment > totalmonthlypayment) {
          totalmonthlypayment = noFeesMonthlyPayment
        }
        const paymentFees = totalmonthlypayment - noFeesMonthlyPayment
        this.updatedPayment = totalmonthlypayment.toFixed(2)
        this.$store.state.userData.paymentPeriods = paymentsPerYear
        this.$store.state.userData.numberOfPayments = pType[1]
        this.$store.state.userData.paymentFees = paymentFees.toFixed(2)
        this.$store.state.userData.loanApr = 27.9
        this.updatedPayment = totalmonthlypayment.toFixed(2)
        this.$store.state.userData.payment = totalmonthlypayment.toFixed(2)
        this.$store.state.userData.invoiceBeforeTax = (this.repairOfferAmount / 1.12).toFixed(2)
        this.$store.state.userData.PrincipalAmount = this.repairOfferAmount * 1 + this.fees * 1
        this.$store.state.userData.newAPR = 27.9
        this.$store.state.userData.vendorToPay = (
          ((1 * this.repairOfferAmount) / 1.12) *
          1.05
        ).toFixed(2)
        if (paymentPeriod[pType[0]] === 1 || paymentPeriod[pType[0]] === 2) {
          var paydate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 3)
          this.$store.state.userData.firstPaymentDay = paydate
        } else {
          var today = new Date()
          today.setDate(today.getDate() + ((12 - today.getDay()) % 7))
          this.$store.state.userData.firstPaymentDay = today
        }
        this.$store.state.userData.totalPayments =
          this.$store.state.userData.payment * paymentsPerYear
        this.$store.state.userData.loanRequested = this.repairOfferAmount
        this.$store.state.userData.costOfFinancing = (
          1 * this.$store.state.userData.totalPayments -
          1 * this.repairOfferAmount
        ).toFixed(2)
        this.$store.state.userData.frequencyText = this.frequencyOfPayments[pType[0]]
        if (paymentPeriod[pType[0]] === 1) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[0]
        } else if (paymentPeriod[pType[0]] === 2) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[1]
        } else if (paymentPeriod[pType[0]] === 2.1666666) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[2]
        } else if (paymentPeriod[pType[0]] === 4.33333333) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[4]
        } else {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[3]
        }
        this.$store.state.userData.term = this.term
      }
    },
    // close calculate payment function

    selectedPlan() {
      var localThis = this
      // const paymentPeriod = [4.34524, 2.17262, 2, 1]
      if (this.calcinput < 10001 && this.calcinput > 499) {
        this.repairOfferAmount = this.calcinput
        let paymentParams
        if (this.poSelected === 'monthly') {
          if (this.selected === 'radio1') {
            paymentParams = [3, 6]
          } else if (this.selected === 'radio2') {
            paymentParams = [3, 12]
          } else if (this.selected === 'radio3') {
            paymentParams = [3, 24]
          } else if (this.selected === 'radio4') {
            paymentParams = [3, 36]
          }
        } else if (this.poSelected === 'semimonthly') {
          if (this.selected === 'radio1') {
            paymentParams = [2, 6]
          } else if (this.selected === 'radio2') {
            paymentParams = [2, 12]
          } else if (this.selected === 'radio3') {
            paymentParams = [2, 24]
          } else if (this.selected === 'radio4') {
            paymentParams = [2, 36]
          }
        } else if (this.poSelected === 'biweekly') {
          if (this.selected === 'radio1') {
            paymentParams = [1, 6]
          } else if (this.selected === 'radio2') {
            paymentParams = [1, 12]
          } else if (this.selected === 'radio3') {
            paymentParams = [1, 24]
          } else if (this.selected === 'radio4') {
            paymentParams = [1, 36]
          }
        } else if (this.poSelected === 'weekly') {
          if (this.selected === 'radio1') {
            paymentParams = [0, 6]
          } else if (this.selected === 'radio2') {
            paymentParams = [0, 12]
          } else if (this.selected === 'radio3') {
            paymentParams = [0, 24]
          } else if (this.selected === 'radio4') {
            paymentParams = [0, 36]
          }
        }

        if (paymentParams) {
          this.calculatePayment.call(this, paymentParams)
        }
      } else if (this.calcinput > 10000) {
        this.updatedPayment = '10K Max.'
      } else if (this.calcinput < 500) {
        this.updatedPayment = '500 Min.'
      }
    },
  },
}
</script>
<style scoped>
/*Typewriter*/

h4 {
  font-size: 2em;
  color: grey;
  text-transform: uppercase;
}
.main-title {
  margin-top: 50px;
}
.paymentBox {
  text-align: center;
  font-weight: bold;
}

span {
  border-right: 0.05em solid;
  animation: caret 1s steps(1) infinite;
}

@keyframes caret {
  50% {
    border-color: transparent;
  }
}

/*background animation*/
.container-fluidback {
  height: 100%;
  margin: 0;
  padding: 0;
  width: 100%;
  background: #fff;
}

/* ============= Animation background ========= */
.background {
  background: linear-gradient(132deg, #e6efed, #dbfcf6, #ffffff);
  background-size: 400% 400%;
  animation: Gradient 15s ease infinite;
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: 0;
  margin: 0;
}

.cube {
  position: absolute;
  top: 80vh;
  left: 45vw;
  width: 10px;
  height: 10px;
  border: solid 1px #d7d4e4;
  transform-origin: top left;
  transform: scale(0) rotate(0deg) translate(-50%, -50%);
  animation: cube 12s ease-in forwards infinite;
}

.cube:nth-child(2n) {
  border-color: #fff;
}

.cube:nth-child(2) {
  animation-delay: 2s;
  left: 25vw;
  top: 40vh;
}

.cube:nth-child(3) {
  animation-delay: 4s;
  left: 75vw;
  top: 50vh;
}

.cube:nth-child(4) {
  animation-delay: 6s;
  left: 90vw;
  top: 10vh;
}

.cube:nth-child(5) {
  animation-delay: 8s;
  left: 10vw;
  top: 85vh;
}

.cube:nth-child(6) {
  animation-delay: 10s;
  left: 50vw;
  top: 10vh;
}

/* Animate Background*/
@keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

@keyframes cube {
  from {
    transform: scale(0) rotate(0deg) translate(-50%, -50%);
    opacity: 1;
  }

  to {
    transform: scale(20) rotate(960deg) translate(-50%, -50%);
    opacity: 0;
  }
}

/*end of back animation*/

.container-fluid {
  height: 100%;
  margin: 0;
  padding: 0;
  width: 100%;
  background: #fff;
}

.radioMonth {
  margin-top: 15px;
}

.titlefont {
  font-family: 'Raleway', sans-serif;
  color: #f15b22 !important;
  font-size: 2rem;
}

.subtitlefont {
  color: #009579 !important;
  font-size: 2rem !important;
}

.offer {
  color: #a0dfd0 !important;
  font-size: 3.5rem !important;
}

.esti {
  display: inline-block;
}

.text-label {
  line-height: 1.5;
  font-size: 1.5rem;
  font-weight: 400;
  font-family: Poppins;
}

.estinumber {
  height: 5rem;
}

#startedbtn {
  background-color: #f6c215 !important;
  color: black;
  white-space: nowrap;
}

.mainback {
  position: relative;
}

.center {
  vertical-align: middle;
}

.phonepos {
  position: absolute;
}

#btnx {
  background-color: #02b349;
  border-color: white;
  border-width: medium;
}

#btnx:hover {
  background-color: green;
}

.paybox {
  background-color: #16443d;
  border-radius: 25px;
}

.estimatebox {
  background-color: #43bea9;
  border-radius: 25px 25px 0px 0px;
  height: 45px;
  width: 100%;
}

.smimgres {
  max-width: 70%;
  max-height: 70%;
  object-fit: contain;
}

#home {
  min-height: 500px;
}
.main-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #f15b22;
}
@media (max-width: 349.9px) {
  .main-title {
  margin-top: 0px !important;
}
  .calcSection {
    min-height: 900px;
  }
  #home {
    min-height: 950px;
    padding-top: 120px;
    margin-left: 0px;
  }
  .btn-secondary {
    font-size: 0.5rem;
  }
  #btn-radios-1 .btn-group-toggle .btn span {
    font-size: 0.25rem !important;
  }
  .adjustFont {
    font-size: 5vw;
  }

  .adjustSmall {
    padding-left: 15px;
  }

  h4 {
    font-size: 0.5rem;
  }

  .row {
    margin-right: 0px !important;
  }

  .mobile {
    margin-left: 0px;
    padding-left: 0px;
  }

  .radioMonth {
    padding-top: 110px;
  }

  .paymentplan {
    padding-bottom: 15px;
  }

  .ml-4,
  .mx-4 {
    margin-left: 0.3rem !important;
  }

  .container {
    margin-left: 0px;
    padding-left: 0px;
  }

  .paymentBox {
    text-align: center;
    font-weight: bold;
  }

  .smimgres {
    display: none;
  }

  .titlefont {
    font-size: 1.5rem !important;
  }

  .subtitlefont {
    font-size: 1rem !important;
  }

  .textestimate {
    text-align: left !important;
  }

  .months {
    padding-top: 90px;
  }

  p.offer {
    line-height: 60px !important;
    margin-bottom: 0px !important;
  }

  .estimatebox {
    background-color: #43bea9;
    border-radius: 25px 25px 0px 0px;
    height: 90px;
    position: absolute;
  }
}

@media (min-width: 350px) and (max-width: 486.5px) {
  .main-title {
  margin-top: 0px !important;
}
  .calcSection {
    min-height: 800px;
  }
  #home {
    min-height: 950px;
    padding-top: 100px;
    margin-left: 0px;
  }

  .adjustFont {
    font-size: 4vw;
  }

  .adjustSmall {
    padding-left: 15px;
  }

  h4 {
    font-size: 0.8rem;
  }

  .row {
    margin-right: 0px !important;
  }

  .mobile {
    margin-left: 0px;
    padding-left: 0px;
  }

  .radioMonth {
    padding-top: 110px;
  }

  .paymentplan {
    padding-bottom: 15px;
  }

  .ml-4,
  .mx-4 {
    margin-left: 0.3rem !important;
  }

  .container {
    margin-left: 0px;
    padding-left: 0px;
  }

  .smimgres {
    display: none;
  }

  .titlefont {
    font-size: 1.5rem !important;
  }

  .subtitlefont {
    font-size: 1rem !important;
  }

  .textestimate {
    text-align: left !important;
  }

  .months {
    padding-top: 90px;
  }

  p.offer {
    line-height: 60px !important;
    margin-bottom: 0px !important;
  }

  .estimatebox {
    background-color: #43bea9;
    border-radius: 25px 25px 0px 0px;
    height: 90px;
    position: absolute;
  }
}

@media (min-width: 486.6px) and (max-width: 767px) {
  .main-title {
    margin-top: 0px !important;
  }
  .calcSection {
    min-height: 750px;
  }
  #home {
    min-height: 950px;
    padding-top: 100px;
  }

  .adjustFont {
    font-size: 4vw;
  }

  .adjustSmall {
    padding-left: 15px;
  }

  h4 {
    font-size: 0.8rem;
  }

  .row {
    margin-right: 0px !important;
  }

  .mobile {
    margin-left: 0px;
    padding-left: 0px;
  }

  .radioMonth {
    padding-top: 110px;
  }

  .paymentplan {
    padding-bottom: 15px;
  }

  .ml-4,
  .mx-4 {
    margin-left: 0.3rem !important;
  }

  .container {
    margin-left: 0px;
    padding-left: 0px;
  }

  .smimgres {
    display: none;
  }

  .titlefont {
    font-size: 1.5rem !important;
  }

  .subtitlefont {
    font-size: 1rem !important;
  }

  .textestimate {
    text-align: left !important;
  }

  .months {
    padding-top: 90px;
  }

  p.offer {
    line-height: 60px !important;
    margin-bottom: 0px !important;
  }

  .estimatebox {
    background-color: #43bea9;
    border-radius: 25px 25px 0px 0px;
    height: 90px;
    position: absolute;
  }
}
@media (min-width: 1000px) and (max-width: 2000px) {
  .bigscreen {
    padding-top: 10px !important;
  }
  .calcSection {
    min-height: 750px;
  }
  #home {
    min-height: 950px;
    padding-top: 100px;
  }
  .estimatebox{
    height: 65px !important;
  }
  .boxheight{
    height: 65px !important;
  }
  .adjustFont {
    font-size: 1.5vw;
  }

  .adjustSmall {
    padding-left: 15px;
  }

  h4 {
    font-size: 0.8rem;
  }

  .row {
    margin-right: 0px !important;
  }

  .mobile {
    margin-left: 0px;
    padding-left: 0px;
  }

  .radioMonth {
    padding-top: 60px;
  }

  .paymentplan {
    padding-bottom: 15px;
  }

  .ml-4,
  .mx-4 {
    margin-left: 0.3rem !important;
  }

  .container {
    margin-left: 0px;
    padding-left: 0px;
  }

  .titlefont {
    font-size: 1.5rem !important;
  }

  .subtitlefont {
    font-size: 1rem !important;
  }

  .textestimate {
    text-align: left !important;
    font-size: 1rem !important;
  }

  .months {
    padding-top: 90px;
  }

  p.offer {
    line-height: 60px !important;
    margin-bottom: 0px !important;
  }
  .img-fluid {
    max-width: 70% !important;
  }

  .estimatebox {
    background-color: #43bea9;
    border-radius: 25px 25px 0px 0px;
    height: 90px;
    position: absolute;
  }
  .calcpart {
    padding-left: 30px;
  }
}
@media (min-width: 768px) and (max-width: 1000px) {
  .calcSection {
    min-height: 750px;
  }
  #home {
    min-height: 950px;
    padding-top: 100px;
  }

  .adjustFont {
    font-size: 3vw;
  }

  .adjustSmall {
    padding-left: 15px;
  }

  h4 {
    font-size: 0.8rem;
  }

  .row {
    margin-right: 0px !important;
  }

  .mobile {
    margin-left: 0px;
    padding-left: 0px;
  }

  .radioMonth {
    padding-top: 110px;
  }

  .paymentplan {
    padding-bottom: 15px;
  }

  .ml-4,
  .mx-4 {
    margin-left: 0.3rem !important;
  }

  .container {
    margin-left: 0px;
    padding-left: 0px;
  }

  .titlefont {
    font-size: 1.5rem !important;
  }

  .subtitlefont {
    font-size: 1rem !important;
  }

  .textestimate {
    text-align: left !important;
    font-size: 1rem !important;
  }

  .months {
    padding-top: 90px;
  }

  p.offer {
    line-height: 60px !important;
    margin-bottom: 0px !important;
  }

  .estimatebox {
    background-color: #43bea9;
    border-radius: 25px 25px 0px 0px;
    height: 90px;
    position: absolute;
  }
}
h2 {
  line-height: 1.5;
  font-size: 2rem;
  font-weight: 900;
  font-family: Poppins;
  color: #009579;
  margin-bottom: 0px !important;
}

h3 {
  font-size: 1.5rem;
}

h5 {
  text-transform: none;
  font-size: 18px;
  font-weight: 300;
}

.container {
  max-width: 1600px;
}
</style>


// WEBPACK FOOTER //
// src/pages/home.vue